import $ from 'jquery';
export const init = async function() {
    // change swatch
    $('.js-gift-wrap-color').on('click', function() {
        // get variant id
        const variantId = $(this).attr('variant_id');
        const variantColor = $(this).attr('color') || '';
        // change color swatch
        $('.js-gift-wrap-color').removeClass('active');
        $('.js-gift-wrap-color[variant_id=' + variantId + ']').addClass('active');
        // change price
        $('.js-gift-wrap-price').removeClass('active');
        $('.js-gift-wrap-price[variant_id=' + variantId + ']').addClass('active');
        // change image
        $('.js-gift-wrap-image').removeClass('active');
        $('.js-gift-wrap-image[variant_id=' + variantId + ']').addClass('active');
        $('.GiftBox-colorLabel span').text(variantColor);
    });
    // add to cart
    $('#js-pdpupsell-btn').on('click', function() {
        const selectedVariantId = $('.js-gift-wrap-price.active').attr('variant_id') || '';
        if (selectedVariantId !== '') {
            const data = {
                id: selectedVariantId,
                quantity: 1
            };
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                async: false,
                complete: function() {
                    $('.js-gift-success').fadeIn();
                    // update value for cart icon
                    const currentCartNumber = $('.js-cart-item-count').attr('data-item-count') || '0';
                    const cartNumber = parseInt(currentCartNumber === '' ? '0' : currentCartNumber) + 1;
                    $('.js-cart-item-count').attr('data-item-count', cartNumber);
                    setTimeout(function() {
                        $('.js-gift-success').fadeOut();
                    }, 2000);
                }
            });
        }
    });
};
